/**
 * DIEUKYDIEU.TV - THEME MANAGER MODULE
 * Handles Dark / Light theme toggling with smooth transitions.
 */

import { state } from './state.js';

export function initTheme() {
    const saved = localStorage.getItem('dieukydieu_theme');
    if (saved === 'light' || saved === 'dark') {
        applyTheme(saved);
        return;
    }
    // No saved preference: follow OS appearance (Apple HIG).
    const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    applyTheme(prefersDark ? 'dark' : 'light');

    // Live-follow OS appearance until user picks manually.
    if (window.matchMedia) {
        const mq = window.matchMedia('(prefers-color-scheme: dark)');
        const onOSChange = (e) => {
            if (!localStorage.getItem('dieukydieu_theme')) {
                applyTheme(e.matches ? 'dark' : 'light');
            }
        };
        if (mq.addEventListener) mq.addEventListener('change', onOSChange);
    }
}

export function applyTheme(theme) {
    state.currentTheme = theme;
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('dieukydieu_theme', theme);

    const icon = document.getElementById('theme-icon');
    if (icon) {
        icon.innerText = theme === 'dark' ? 'light_mode' : 'dark_mode';
    }

    const sidebarIcon = document.getElementById('sidebar-theme-icon');
    if (sidebarIcon) {
        sidebarIcon.innerText = theme === 'dark' ? 'light_mode' : 'dark_mode';
    }
    const sidebarText = document.getElementById('sidebar-theme-text');
    if (sidebarText) {
        sidebarText.innerText = theme === 'dark' ? 'Giao diện tối' : 'Giao diện sáng';
    }

    // Notify listeners (e.g. seekbar update)
    window.dispatchEvent(new CustomEvent('dkd:themechange', { detail: { theme } }));
}

export function toggleTheme() {
    const current = document.documentElement.getAttribute('data-theme') || 'dark';
    applyTheme(current === 'dark' ? 'light' : 'dark');
}
